import { createAction } from 'redux-actions';

export const NAMES = {
  SET: 'CLIENT.VIDEO.FULLSCREEN_STATUS.SET',
};

export const setFullScreenStatus = createAction(NAMES.SET);



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/player/set-fullscreen-status.js